module.exports = __webpack_public_path__ + "img/wash_baby_4.c9042419.png";